import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {inject} from "vue";
import {Site} from "@/enums/Site";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressSiteSeparator',
  setup(__props) {

const site = inject("tressSite");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(site) == _unref(Site).Green)
      ? _renderSlot(_ctx.$slots, "green", { key: 0 })
      : _createCommentVNode("", true),
    (_unref(site) == _unref(Site).Blue)
      ? _renderSlot(_ctx.$slots, "blue", { key: 1 })
      : _createCommentVNode("", true)
  ], 64))
}
}

})